import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';

import ChildProfile from '../Children/Profile';
import ChildGuardians from "..//Children/ChildGuardians";
import ChildReleases from "../Children/ChildReleases";
import ChildMedical from "../Children/ChildMedical";
import ChildAcademic from "../Children/Academic";
import ChildNotes from "../Children/ChildNotes"
import ChildRates from "../Children/Rates";
import ChildSchedule from "../Children/Schedule";
import ChildDocuments from "../Children/Documents";
import ChildAuditLog from "../Children/AuditLog";
import ChildCharges from "../Children/Charges";
import ChildAttendances from "../Children/Attendances";
import ChildClassrooms from "../Children/ChildClassrooms";

export default function childBreadcrumb<T extends RouteComponentProps>(
    WrappedComponent: React.ComponentType<T>,
    fetchChildAccountName: (childId: number) => Promise<any>,
    options: { page?: string } = { }
) {

    type State = {
        accountId: number;
        accountName: string;
        childId: number;
        childName: string;
        links: ApiLink[];
    }

    type Props = RouteComponentProps<{ childId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props) {
            super(props);

            this.state = {
                accountId: 0,
                accountName: '',
                childId: 0,
                childName: '',
                links: []
            }

            this.open = this.open.bind(this);
        }

        componentDidMount() {
            const childId = parseInt(this.props.match.params.childId);
            fetchChildAccountName(childId)
                .then((response) => {
                    this.setState({ ...response });
                })

        }

        componentWillReceiveProps(nextProps: Props) {
            const childId = parseInt(nextProps.match.params.childId)

            if (childId !== this.state.childId) {
                fetchChildAccountName(childId)
                    .then((response) => {
                        this.setState({ ...response });
                    })
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {this.state.accountName &&
                        <li className="breadcrumb-item">
                            <Link to={`/accounts/${this.state.accountId}`}>{this.state.accountName}</Link>
                        </li>}
                    {!options.page && <li className="breadcrumb-item active" aria-current="page">{this.state.childName}</li>}
                    {options.page && <React.Fragment>
                        <li className="breadcrumb-item">
                            <Link to={`/child/${this.props.match.params.childId}`}>{this.state.childName || 'Child'}</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {options.page}
                        </li>
                    </React.Fragment>}
                </ol>
                </nav>
                <ul className="nav nav-tabs">
                    {this.state.links.find(x => x.Rel === "Profile") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildProfile.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Profile"))}
                        >
                            Child
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Guardians") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildGuardians.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Guardians"))}
                        >
                            Guardians
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Releases") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildReleases.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Releases"))}
                        >
                            Releases
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Medical") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildMedical.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Medical"))}
                        >
                            Medical
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Academic") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildAcademic.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Academic"))}
                        >
                            Academic
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Notes") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildNotes.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Notes"))}
                        >
                            Notes
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Charges") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildCharges.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Charges"))}
                        >
                            Charges
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Schedule") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildSchedule.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Schedule"))}
                        >
                            Schedule
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Rates") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildRates.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Rates"))}
                        >
                            Rates
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Attendance") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildAttendances.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Attendance"))}
                        >
                            Attendance
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Classrooms") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildClassrooms.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Classrooms"))}
                        >
                            Classrooms
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Documents") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildDocuments.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Documents"))}
                        >
                            Documents
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Logs") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === ChildAuditLog.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Logs"))}
                        >
                            Logs
                        </a>
                    </li>}
                </ul>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
        }

        private open(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, link: ApiLink | undefined): void {
            if (link) {
                e.preventDefault();
                this.props.history.push(link.Href);
            }
        }
    };
}
